import React from 'react';

import Container from 'components/Container';
import MetaDescription from 'components/MetaDescription';
import MetaTitle from 'components/MetaTitle';
import Spaced from 'components/Spaced';
import Typography from 'components/Typography';
import { Exhibition } from 'types/Exhibition';
import { truncate } from 'utils';
// import styles from './Exhibition.module.css';

type ExhibitionProps = Exhibition;

const Exhibition: React.FCWithChildren<ExhibitionProps> = props => {
  const { title, subtitle, children } = props;

  return (
    <Spaced spacing={3}>
      <MetaTitle>{title}</MetaTitle>
      <MetaDescription>{truncate(subtitle ?? title, 150)}</MetaDescription>
      <Container>
        <Typography component="h1" block uppercase variant="big">
          {title}
        </Typography>
        <Typography component="h2" block color="faded" uppercase variant="big">
          {subtitle}
        </Typography>
      </Container>
      <Spaced spacing={6}>{children}</Spaced>
    </Spaced>
  );
};

export default Exhibition;
